module.exports = __webpack_public_path__ + "media/images/board-view-icon-transparent-background-e6b55135c47e6a83251123e5249dbef3.svg";